/**
 * Data collection for all payments, fetched from a JSON file.
 * @type {webix.DataCollection}
 */
export const allpayments = new webix.DataCollection({
    /**
     * URL to fetch payment data in JSON format.
     * @type {string}
     */
    url: 'data/payments.json',
    scheme: {
        /**
         * Initialization function to process each payment object.
         * @param {Object} obj - The payment object to be initialized.
         */
        $init: function (obj) {
            /**
             * Parse and format the date from the payment object.
             * @type {Date}
             */
            obj.date = webix.i18n.parseFormatDate(obj.date);
            /**
             * Get the current month index (0-11).
             * @type {number}
             */
            const curr_month = new Date().getMonth();
            /**
             * Get the month index from the payment date (0-11).
             * @type {number}
             */
            const data_month = obj.date.getMonth();
            /**
             * Adjust the payment date's month based on its ID and current month.
             */
            if (curr_month - data_month > 0) {
                if (obj.id < 25) obj.date.setMonth(curr_month);
                else if (obj.id >= 25) obj.date.setMonth(curr_month - 1);
            }
        },
    },
});

// FILE DOCUMENTED
